import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bluePlus",
  "use": "bluePlus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"bluePlus\"><g data-name=\"icon - more - 24px\" transform=\"translate(-571 -681)\"><circle cx=\"12\" cy=\"12\" r=\"12\" transform=\"translate(571 681)\" fill=\"#031425\" /><g data-name=\"↳color\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"1.25\"><path data-name=\"Line 152\" d=\"M583 689v8\" /><path data-name=\"Line 153\" d=\"M579 693h8\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol